import { useState } from 'react';
import { Link } from 'react-router-dom';
import { tracking } from '../utils/tracking';
import { svgs } from '../assets/svgs';
import {
   RegisterCards,
   SponsorSection,
   StatsBanner,
   VideoSection,
   FeaturedSectors,
   SpeakerCards,
   FooterForm,
   TestimonialCarousel,
   Banner,
   DiscountPopup,
} from '../components';
import { imgs } from '../assets/imgs';
// import video from '../assets/videos/homepagevideo.mp4'
import { useResizeImg } from '../hooks/useResizeImg';
import { VCLogos } from '../components/home/VCLogos';

const cards1 = [
   {
      img: imgs.home.registerCard4,
      title: 'INNOVATIVE TECHNOLOGIES',
      content1: 'An exclusive group of startups will be selected to showcase their technology, innovation, and products.',
      content2: 'All presenters are pre-vetted and will put their groundbreaking, innovative, and up-and-coming technology startups on display.',
      btnTxt: 'APPLY TO PRESENT',
      btnLink: 'startups',
      btnColor: '#02D8DD',
      btnId: 277
   },
   {
      img: imgs.home.registerCard5,
      title: 'EXCLUSIVE NETWORKING',
      content1: 'Make connections using the matchmaking platform or at the networking area.',
      content2: 'Connect with and join the ever-growing group of active investors, C-level executives, corporate development professionals, press, and the visionary entrepreneurs that make our summits the premier annual venture experience for many.',
      btnTxt: 'GET YOUR TICKET',
      btnLink: 'registration',
      btnColor: '#00C2FF',
      btnId: 275
   },
   {
      img: imgs.home.registerCard6,
      title: 'INSIGHTFUL CONTENT',
      content1: 'We’re bringing together a fantastic group of top-tier VCs, Corporate VCs and Angel Investors to illuminate the issues facing Investors and Startup CEOs alike, debate what’s next for technology, educate about a wide variety of subjects, and provide updated analyses and share their experience with the audience.',
      content2: '',
      btnTxt: 'APPLY TO SPEAK',
      btnLink: 'speakers',
      btnColor: '#0075FF',
      btnId: 276
   },
];
const cards2 = [
   {
      img: imgs.home.registerCard1,
      title: 'NOMINATE A COMPANY',
      content1: 'Nominate your colleagues, portfolio companies, or partners for the opportunity to present!',
      content2: '',
      btnTxt: 'NOMINATE A STARTUP',
      btnLink: 'https://youngstartup.com/nominations',
      btnColor: '#02D8DD',
      btnId: 347
   },
   {
      img: imgs.home.registerCard2,
      title: 'VENTURE NURTURING',
      content1: 'Free access for seed stage startups 25 Tickets Available',
      content2: '*Conditions Apply',
      btnTxt: 'GET MORE DETAILS',
      btnLink: 'venture-nurturing',
      btnColor: '#00C2FF',
      btnId: 348
   },
   {
      img: imgs.home.registerCard3,
      title: 'PRESS PASSES',
      content1: 'If you qualify and would like a press pass, visit here for details.',
      content2: '',
      btnTxt: 'GET YOUR PRESS PASS',
      btnLink: 'press',
      btnColor: '#0075FF',
      btnId: 281
   },
];
const vidUrl = "https://www.youtube.com/embed/KZ_SWkS-Ojg?&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&playlist=KZ_SWkS-Ojg";
const vidHeader = "VIDEO HIGHLIGHTS";

export const Home = () => {
   document.title = "New York Venture Summit | Overview";
   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.home.desktopBanner, imgs.home.mobileBanner)
   const collageImageSource = useResizeImg(imgs.home.desktopCollage, imgs.home.mobileCollage)
   return (
      <div className='home'>
         <div className='top-section'>
            <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
               {svgs.eventLogo}
               <h2>September 6<sup>th</sup> & 7<sup>th</sup>, 2023</h2>
               <h3>Javits Center, New York City</h3>
               {/* <div className='btns'>
               <Link className='btn' to='/registration' onClick={() => tracking(271)} >Tickets</Link>
               <Link className='btn' to='/partners' onClick={() => tracking(272)} >Partners</Link>
            </div> */}
               <h1>WHERE INNOVATION MEETS CAPITAL<sup>TM</sup></h1>
               {/* <video autoPlay loop muted>
                  <source src={video} type='video/mp4' />
            </video> */}
            </Banner>
            <VCLogos />
         </div>
         <DiscountPopup />
         <StatsBanner />
         <SpeakerCards isSliced={true} />
         <RegisterCards cards={cards1} header={'This exclusive Venture Capital Summit will feature:'} />
         <VideoSection url={vidUrl} header={vidHeader} />
         <TestimonialCarousel pageName={"overview;"} />
         <FeaturedSectors />
         <img src={collageImageSource} alt="collage-Image" />
         <RegisterCards cards={cards2} />
         <SponsorSection />
         <FooterForm />
      </div>
   );
};